import { createSvgIcon } from "@mui/material";

export const TwoDIcon = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M13.2471 9.41895C13.5003 9.41898 13.7337 9.55526 13.8506 9.75L18.0791 16.4912C18.1763 16.6664 18.2343 16.8611 18.2344 17.0752C18.2344 17.6596 17.7475 18.1464 17.1631 18.1465H6.97363C6.31123 18.1465 5.76562 17.6204 5.76562 16.958C5.76573 16.7438 5.84406 16.5297 5.94141 16.3545L8.5127 12.127C8.59061 12.0101 8.74646 11.9122 8.88281 11.9121C9.03867 11.9121 9.17505 12.0101 9.27246 12.127L10.208 13.666L12.6621 9.75C12.779 9.55518 13.0133 9.41895 13.2471 9.41895Z"
      fill="currentColor"
    />
    <path
      d="M8.31836 6.93652C8.88303 6.93668 9.38944 7.24857 9.68164 7.71582C9.95433 8.20276 9.9542 8.80688 9.68164 9.27441C9.38948 9.76135 8.88317 10.0536 8.31836 10.0537C7.77285 10.0537 7.26587 9.76147 6.97363 9.27441C6.70109 8.80689 6.70095 8.20276 6.97363 7.71582C7.2659 7.24843 7.77298 6.93652 8.31836 6.93652Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3125 3.25C19.1875 3.25 20.75 4.8125 20.75 6.6875V17.3125C20.75 19.2266 19.1875 20.75 17.3125 20.75H6.6875C4.77344 20.75 3.25 19.2266 3.25 17.3125V6.6875C3.25 4.8125 4.77344 3.25 6.6875 3.25H17.3125ZM6.6875 4.5C5.47656 4.5 4.5 5.51562 4.5 6.6875V17.3125C4.5 18.5234 5.47656 19.5 6.6875 19.5H17.3125C18.4844 19.5 19.5 18.5234 19.5 17.3125V6.6875C19.5 5.51563 18.4844 4.5 17.3125 4.5H6.6875Z"
      fill="currentColor"
    />
  </svg>,
  "2DIcon",
);
